{
    "account": "Tili",
    "add_bookmark": "Lisää suosikkeihin",
    "add_date": "Lisää päivämäärä",
    "ago": "{{duration}} sitten",
    "api_key": "API-avain",
    "are_you_sure": "Oletko varma?",
    "ask_delete_message": "Poistaako tämän viestin?",
    "audio_not_ready": "Audio ei ole vielä valmis.",
    "bookmark_added": "Viesti suosikeissa.",
    "bookmark_removed": "Viestin poistettu suosikeista.",
    "bookmarks": "suosikit",
    "cancel": "Peruuta",
    "cancel_write": "Haluatko todella peruuttaa uuden viestin kirjoittamisen?",
    "changed_group_name": "muutti ryhmän nimeä",
    "confirm_password_placeholder": "Vahvista salasana",
    "connect": "Yhteys",
    "create_a_group": "Luo ryhmä",
    "create_the_group": "Luo ryhmä",
    "daily": "Päivittäin",
    "default_group": "Oletusryhmä",
    "delete": "Poista",
    "destroy_account_explain": "Kun olet poistanut tilisi, paluuta ei ole. Ole varma.",
    "destroy_account": "Poista tilisi",
    "edit": "Muokkaa",
    "email_input": "Täytä sähköpostiosoitteesi täällä",
    "email": "Sähköposti",
    "empty_message": "Viesti on tyhjä eikä sitä voi lähettää.",
    "error_new_message": "Virhe tapahtui viestin lähettämisen yhteydessä.",
    "error": "Tapahtui virhe",
    "error_upload": "Latauksen aikana tapahtui virhe",
    "forgot_password": "Unohditko salasanasi?",
    "group_left": "Sinä jätit ryhmän.",
    "group_share_choice": "Mihin ryhmään haluat lähettää tämän viestin?",
    "groups": "Ryhmät",
    "group_updated": "Ryhmä on päivitetty.",
    "has_commented_on": "on kommentoinut",
    "has_joined": "on liittynyt",
    "has_left": "on poistunut",
    "has_posted_in": "on julkaissut",
    "hourly": "Tunneittain",
    "in": "ryhmässä",
    "Invalid login/password": "Virheellinen käyttäjätunnus tai salasana",
    "invitation_link": "Kutsulinkki",
    "invitation_welcome": "Tervetuloa Zusamiin. Rekisteröidy ennen ryhmään liittymistä.",
    "just_now": "Juuri nyt",
    "lang": "kieli",
    "login_input": "Valitse käyttäjätunnus",
    "login": "Kirjaudu sisään",
    "login_placeholder": "sähköposti",
    "logout": "Kirjaudu ulos",
    "mark_all_as_read": "merkitä kaikki luetuiksi",
    "monthly": "Kuukausittain",
    "multiple_photos_upload": "Tapahtui virhe. Yritä ladata kuvat yksi kerrallaan (tämä voi tapahtua joissakin selaimissa)",
    "name_input": "Valitse nimi",
    "name": "Nimi",
    "new_password_placeholder": "uusi salasana",
    "next_coms": "Katso seuraavat kommentit",
    "none": "Ei mikään",
    "notification_emails": "Sähköpostiilmoitukset",
    "notification_emails_stopped": "Sähköpostiilmoitukset lakkautettiin!",
    "notifications": "ilmoitukset",
    "parent_message": "Lähdeviesti",
    "password_input": "Kirjoita uusi salasana tähän",
    "password_placeholder": "salasana",
    "password_reset_mail_sent": "Etsi salasanan palauttamisen sähköpostia postilaatikkoosi.",
    "password": "Salasana",
    "passwords_dont_match": "Salasanat eivät täsmää",
    "previous_coms": "Katso aiemmat kommentit",
    "public_link": "julkinen linkki",
    "publish_in_group": "julkaista ryhmässä",
    "quit_group": "Poistu ryhmästä",
    "remove_bookmark": "Poista suosikeista",
    "replies_one": "{{count}} vastaus",
    "replies_other": "{{count}} vastausta",
    "reply": "vastaa",
    "reset_api_key": "API-avain (sinut katkaistaan.)",
    "reset_invitation_link": "Nollaa kutsulinkki",
    "reset_password_title": "Palauta salasanasi",
    "save_changes": "Tallenna muutokset",
    "search_in_group": "hae tästä ryhmästä",
    "search_without_result": "Hakusi ei vastannut mitään viestiä.",
    "settings": "Asetukset",
    "settings_updated": "Asetuksesi päivitettiin",
    "share_message": "jaa viesti",
    "signup": "Rekisteröidy",
    "submit": "Lähetä",
    "text_placeholder": "Kirjoita viestisi tähän",
    "the_message_from": "viestistä",
    "title_placeholder": "Sinun viestisi otsikko (valinnainen)",
    "to": "nimeksi",
    "upload_audio": "Lisää audiotiedosto.",
    "upload_image": "Lisää kuvia",
    "upload_music": "Lisää musiikkia",
    "upload_pdf": "Lisää PDF",
    "upload_video": "Lisää video",
    "User not found": "Käyttäjää ei löytynyt",
    "users": "käyttäjät",
    "video_not_ready": "Video ei ole vielä valmis.",
    "weekly": "Viikoittain"
}
